module.exports = __webpack_public_path__ + "img/img.b67286c2.png";